/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ContactDetails } from "../../models/contact-details";
import { ContactUpdate } from "../../models/contact-update";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface UpdateContact$Params {
  organisation_id: string;
  contact_id: number;
  check?: boolean;
  body: ContactUpdate;
}

export function updateContact(
  http: HttpClient,
  rootUrl: string,
  params: UpdateContact$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContactDetails | Status>> {
  const rb = new RequestBuilder(rootUrl, updateContact.PATH, "patch");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("contact_id", params.contact_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactDetails | Status>;
    }),
  );
}

updateContact.PATH = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";
